import ConditionalWrap from "conditional-wrap"

import { IconButton } from "@trueskin-web/components"
import { simpleEditIcon } from "@trueskin-web/theme/icons/simpleEditIcon"
import { Trans } from "@trueskin-web/translations"

const Service = ({ title, description, onEditClick, price, className }) => (
  <div
    data-testid="web-portal-summary-line-item"
    data-title={title.toLowerCase().replace(" ", "_")}
    sx={{
      display: "flex",
      gap: 3,
      color: price.indexOf("-") !== -1 ? "statusNegativeDark" : "text",
    }}
    className={className}
  >
    <div>
      <ConditionalWrap
        condition={Boolean(onEditClick)}
        wrap={(children) => (
          <span data-testid="web-portal-summary-product-title">{children}</span>
        )}
      >
        {title}
      </ConditionalWrap>
      <div
        sx={{
          fontSize: 1,
          color: "brandNeutralsDarkGrey",
        }}
      >
        {description ? (
          <ConditionalWrap
            condition={Boolean(onEditClick)}
            wrap={(children) => (
              <span data-testid="web-portal-summary-subscription-title">
                {children}
              </span>
            )}
          >
            {description}
          </ConditionalWrap>
        ) : null}
        {onEditClick ? (
          <IconButton
            data-testid="web-portal-summary-change-plan-btn"
            iconSize="sm"
            onClick={onEditClick}
            icon={simpleEditIcon}
            sx={{ ml: 1, mt: "-4px", color: "text" }}
          />
        ) : null}
      </div>
    </div>
    <div sx={{ ml: "auto" }}>
      {price.startsWith("0,0") ? (
        <Trans i18nKey="Payment.Overview.feesIncluded" />
      ) : (
        price
      )}
    </div>
  </div>
)

const Services = ({ services, onEditClick }) => {
  const getServiceItemStyle = (index) => {
    if (
      services[index].type === "discount" &&
      services[index - 1].type !== "discount"
    ) {
      return {
        pt: 4,
        borderTop: "1px",
        borderColor: "brandNeutralsMediumGrey",
      }
    }
  }

  return (
    <div
      data-testid="web-portal-summary-line-items-list"
      sx={{
        display: "grid",
        gap: 4,
        pt: 4,
        pl: 0,
      }}
    >
      {services.map((service, index) => (
        <Service
          {...service}
          {...(index === 0 ? { onEditClick } : undefined)}
          key={index}
          sx={{
            ...getServiceItemStyle(index),
          }}
        />
      ))}
    </div>
  )
}

export default Services
